import { Flex, IconButton } from '@chakra-ui/react'
import { CheckBox, InputContainer, Menu, MinusCircleIcon, TextField } from 'components'
import { startCase } from 'lodash'
import { LookupOutputProp, LookupOutputProps } from 'types'

interface AdditionalMappingProps {
  rowKey: number
  dbInputProp: string
  lookupOutputProps: LookupOutputProp[]
  updateOutputProps: (props: LookupOutputProps) => void
  dbFields: string[]
  handleRemoveRow: (rowId: number) => void
}

export function SmartColumnAdditionalMapping({
  rowKey,
  dbInputProp,
  lookupOutputProps,
  updateOutputProps,
  dbFields,
  handleRemoveRow,
}: AdditionalMappingProps) {
  return (
    <Flex gap={5} ml={{ base: 'auto', lg: '322px' }} h="65px" align="flex-end">
      <Menu
        variant="outline"
        menuProps={{
          matchWidth: true,
        }}
        w={optionWidths}
        borderRadius="10px"
        label="Mapped Field"
        buttonLabel={lookupOutputProps.find(row => row.index === rowKey)?.dbField ?? ''}
        options={dbFields
          ?.filter(
            key => !lookupOutputProps.some(row => row.dbField === key) && key !== dbInputProp
          )
          .map(property => ({
            type: 'item',
            label: startCase(property),
            value: property,
          }))}
        onChange={value => {
          updateOutputProps({ index: rowKey, updateOn: 'field', dbField: value })
        }}
      />
      <InputContainer label="New Mapped Field Name" px={1}>
        <TextField
          size="sm"
          h="40px"
          isDisabled={!lookupOutputProps[0]}
          w={optionWidths}
          borderRadius="10px"
          placeholder="Enter field name..."
          onChange={e =>
            updateOutputProps({
              index: rowKey,
              updateOn: 'fieldName',
              fieldName: e.target.value,
            })
          }
        />
      </InputContainer>

      <InputContainer label="Use for Analytics Charts" px={1} h="65px">
        <Flex h="40px" align="center" justify="center">
          <CheckBox
            w="25px"
            h="25px"
            isChecked={!!lookupOutputProps[rowKey].hasChart}
            onChange={() =>
              updateOutputProps({
                index: rowKey,
                updateOn: 'hasChart',
              })
            }
          />
        </Flex>
      </InputContainer>

      <IconButton
        aria-label="remove-mapping"
        bg=""
        icon={<MinusCircleIcon type="outline" color="red" fontSize="xl" />}
        onClick={() => handleRemoveRow(rowKey)}
      />
    </Flex>
  )
}

const optionWidths = { base: '100%', lg: '250px' }
